import { Http } from '../../../support';

const initialState = {
  isValid: false,
  busy: false,
  data: {},
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.customization = {
      ...state.app.emisores.customization,
      ...data,
    };
  });
};

const update = async (store, data, id, live = false) => {
  store.setState((state) => {
    state.app.emisores.customization.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': live ? 'fa/live' : undefined,
    };

    const params = {
      include: 'series,config',
    };

    const response = await Http.put(`api/emisores/${id}`, data, { headers, params });

    store.setState((state) => {
      state.app.emisores.customization.busy = false;
      state.app.emisores.customization.result = response;
      state.app.emisores.customization.data = {
        ...state.app.emisores.customization.data,
        ...response.data,
        series: response.data.series || [],
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.customization.busy = false;
      state.app.emisores.customization.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.customization = { ...initialState };
  });
};

const EmisorCustomizationStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    update,
    reset,
  },
};

export default EmisorCustomizationStore;
